// eslint-disable-next-line import/prefer-default-export
export const transitQueryKeys = {
  guaranteesByParams: (params: { transitOperationId: number | null }) => ['v2/consignment', params],
}
